const products = [
  { num: '01', name: 'Viga IPR', desc: 'Perfil estructural de acero para construcción de marcos y estructuras.' },
  { num: '02', name: 'Varilla corrugada', desc: 'Varilla y mallas para refuerzo de concreto en obra civil.' },
  { num: '03', name: 'Ángulos', desc: 'Ángulo de acero en diversas medidas estándar.' },
  { num: '04', name: 'PTR', desc: 'Perfil tubular rectangular y cuadrado de acero.' },
  { num: '05', name: 'Canal CPS', desc: 'Canal estructural de acero tipo C para armaduras y estructuras.' },
  { num: '06', name: 'Soleras', desc: 'Barra plana de acero para herrería y fabricaciones.' },
  { num: '07', name: 'Cuadrados y redondos', desc: 'Barra cuadrada y barra redonda de acero macizo.' },
  { num: '08', name: 'Lámina negra', desc: 'Lámina de acero negro en calibres estándar.' },
  { num: '09', name: 'Lámina galvanizada', desc: 'Lámina galvanizada para techos, fachadas y cubiertas.' },
  { num: '10', name: 'Lámina antiderrapante', desc: 'Placa de acero con acabado antiderrapante para pisos y rampas.' },
];

export default function Products() {
  return (
    <section id="productos" className="products">
      <div className="container">
        <div className="section-header">
          <p className="section-overline">Lo que ofrecemos</p>
          <h2 className="section-title light">Nuestros Productos</h2>
          <div className="section-divider" />
        </div>

        <div className="products-list">
          {products.map(({ num, name, desc }) => (
            <div key={num} className="product-row">
              <span className="product-row-num">{num}</span>
              <div className="product-row-line" />
              <div className="product-row-body">
                <h3 className="product-row-name">{name}</h3>
                <p className="product-row-desc">{desc}</p>
              </div>
              <div className="product-row-arrow">→</div>
            </div>
          ))}
        </div>

        <div className="strip" style={{ marginTop: '48px' }}>
          <div className="strip-inner">
            <span className="strip-label">Nota</span>
            <span className="strip-text">
              También manejamos materiales adicionales — consulta disponibilidad y precios directamente con nosotros.
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
